import { render, staticRenderFns } from "./CompraCreate.vue?vue&type=template&id=ad9bca50&scoped=true"
import script from "./CompraCreate.vue?vue&type=script&lang=js"
export * from "./CompraCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9bca50",
  null
  
)

export default component.exports